export const mutations = {
  STORE_FILEOPENEDDATE(state, fileopeneddates) {
    state.fileopeneddates = fileopeneddates;
  },
  STORE_FILEOPENEDDATES(state, data) {
    state.data = data;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/reports/mutations.js